import React from 'react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://checkout.sectordigital.online/cart/43923963838507:1';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  onClick,
  href
}: CTAButtonProps) {
  return <motion.a href={href || CHECKOUT_URL} target={href ? undefined : '_blank'} rel={href ? undefined : 'noopener noreferrer'} onClick={e => {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  }} className={`inline-block bg-amber text-navy font-bold text-center py-4 px-6 rounded-lg shadow-lg hover:bg-gold transition-colors duration-300 ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 0px 0px rgba(232, 184, 48, 0.4)', '0px 0px 20px 5px rgba(232, 184, 48, 0.4)', '0px 0px 0px 0px rgba(232, 184, 48, 0.4)']
  }} transition={{
    duration: 2,
    repeat: Infinity,
    repeatType: 'reverse'
  }} data-id="element-35">
      {children}
    </motion.a>;
}